import { render } from "./MDataTable.vue?vue&type=template&id=3f7680b7"
import script from "./MDataTable.vue?vue&type=script&lang=js"
export * from "./MDataTable.vue?vue&type=script&lang=js"

import "./MDataTable.vue?vue&type=style&index=0&id=3f7680b7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__